<small>
  <span>
    <strong>{{ 'dispenserAgreement.minimumDispatchTime' | cxTranslate: { time: dispatchHours } }}</strong>
  </span>
</small>
